import React from 'react';
import classNames from 'classnames';
import { EMPTY_FN, isNil } from '@libs/shared';

export interface IDialogForMobile {
    className?: string;
    visible?: boolean;
    style?: React.CSSProperties;
    title?: React.ReactNode;
    message?: React.ReactNode;
    text4Ok?: string;
    text4Cancel?: string;
    onOk?: () => void | Promise<void>;
    onCancel?: () => void | Promise<void>;
    onClose?: () => void;
}

const DialogForMobile: React.FC<IDialogForMobile> = (props) => {
    const {
        className,
        style,
        title,
        message,
        text4Cancel,
        text4Ok,
        visible,
        onOk = EMPTY_FN,
        onCancel = EMPTY_FN
    } = props;

    const renderTitle = () => {
        if (!title) {
            return null;
        }
        return <div className="dialog-title">{title}</div>;
    };

    const renderMessage = () => {
        if (!message) {
            return null;
        }
        return <div className="dialog-message">{message}</div>;
    };

    const renderFooter = () => {
        if (isNil(text4Cancel) && isNil(text4Ok)) {
            return null;
        }

        return (
            <div className="dialog-footer">
                {!isNil(text4Cancel) && (
                    <div className="dialog-btn cancel type-gray" onClick={onCancel}>
                        {text4Cancel}
                    </div>
                )}
                {!isNil(text4Ok) && (
                    <div className="dialog-btn ok type-default" onClick={onOk}>
                        {text4Ok}
                    </div>
                )}
            </div>
        );
    };

    if (!visible) {
        return null;
    }

    return (
        <div className={classNames('fx-dialog-mobile', className)} style={style}>
            <div className="dialog-wrapper">
                <div className="dialog-body">
                    {renderTitle()}
                    {renderMessage()}
                </div>
                {renderFooter()}
            </div>
        </div>
    );
};

export default DialogForMobile;
